import { StyleSheet } from 'react-native'

export const ThemedSelectStyles = StyleSheet.create( {
	select: {
		width: '100%',
	},
})
